

export const ON_UPDATE = 'VIEW_ONCHANGE';
export const updatePreferedAddress = (value) => ({
    type: ON_UPDATE,
    payload: {
        value
    },
}
);



